@for (action of actions; track action; let actionIndex = $index) {
  <div class="mb-4">
    <div class="flex items-center">
      <p-radio-button
        [disabled]="action.disabled"
        [inputId]="'nextAction' + actionIndex"
        [value]="action.value"
        [(ngModel)]="nextAction"
      ></p-radio-button>
      <label class="ml-2" [for]="'nextAction' + actionIndex">{{ action.label }}</label>
    </div>
  </div>
}

@if (showWarning) {
  <p-message
    class="block w-100 mb-4"
    severity="warn"
    styleClass="block w-100 p-message-sm"
  >{{ warningMessage }}</p-message>
} @else {
  @if (continuedStayMessage?.severity === 'info') {
    <div class="mb-4">
      <p-message
        class="instruction-message secondary-message"
        severity="info"
      >{{ continuedStayMessage?.detail }}</p-message>
    </div>
  } @else {
    @if (actionsMap['continuedStay'].disabled) {
      <div class="mb-4">
        <p-message
          class="instruction-message"
          severity="warn"
        >{{ continuedStayMessage?.detail }}</p-message>
      </div>
    }
  }
}


<div class="flex justify-end">
  <button
    class="p-button-secondary mr-2"
    label="Cancel"
    pButton
    (click)="onCancel()"
  ></button>
  <button
    label="Continue"
    pButton
    [disabled]="!nextAction"
    (click)="onContinue(nextAction)"
  ></button>
</div>
